import React from "react";
import { useParams } from "react-router-dom";

import CheckersBoard from "./CheckersBoard";
import CheckersStatusBar from "./CheckersStatusBar";
import CheckersResult from "./CheckersResult";
import { useCheckersGame } from "./hooks/useCheckersGame";
import GameBoardFrame from "../games/GameBoardFrame";

export default function CheckersMPPage() {
  const { id: gameId } = useParams();
  const { state, move } = useCheckersGame(gameId, { multiplayer: true });
  const { game, myPiece, status, error, wsStatus } = state;
  const boardMaxWidthStyle = "min(88vw, 640px, calc(100dvh - 260px))";

  return (
    <GameBoardFrame>
      {status === "loading" && <div className="text-text-secondary text-sm py-8">Loading game...</div>}
      {status === "error" && <div className="text-brand-rose text-sm py-4">{error}</div>}

      {game && status !== "error" ? (
        <>
          <div className="w-full flex flex-col items-center">
            <div className="w-full">
              <CheckersStatusBar
                currentTurn={game.current_turn}
                myPiece={myPiece}
                winner={game.winner}
                isCompleted={game.is_completed}
                p1Name={game.player_one_name || "Red"}
                p2Name={game.player_two_name || "Blue"}
                wsStatus={wsStatus}
                maxWidthStyle={boardMaxWidthStyle}
              />
            </div>
            <CheckersBoard
              board={game.board}
              legalMoves={game.legal_moves}
              myPiece={myPiece}
              currentTurn={game.current_turn}
              isGameOver={game.is_completed}
              onMove={move}
              maxWidthStyle={boardMaxWidthStyle}
            />
          </div>
          <div className="w-full min-h-[76px] sm:min-h-[96px] flex items-start justify-center">
            <CheckersResult
              isCompleted={game.is_completed}
              winner={game.winner}
              myPiece={myPiece}
            />
          </div>
        </>
      ) : null}
    </GameBoardFrame>
  );
}
